<template>
  <div class="page-verify">
    <div class="columns">
      <div class="column is-4 is-offset-4">
        <div class="box section">

          <section class="header has-text-centered">
            <h1>Email Verification</h1>
          </section>

          <div class="columns">
            <div class="column is-8 is-offset-2">
              <div class="login-form form-horizontal">

                <div class="control notification is-danger" v-if="error">
                  <button class="delete" @click="error = undefined"></button>
                  {{ error }}
                </div>

                <form-input
                  type="token" name="token"
                  fa="key" mdi="vpn_key"
                  placeholder="Verification Token"
                  :value="token"
                  @onInput="onInput"
                  :error="errors.token"
                  required=true
                  autofocus=true
                  :disabled="isLoading"
                  v-if="!success">
                </form-input>

                <p class="control submit" v-if="!success">
                  <button class="button is-primary is-outlined is-fullwidth"
                    @click="submit(token)"
                    :class="{ 'is-loading': isLoading }">
                    Verify
                  </button>
                </p>

                <div class="control notification is-primary" v-if="success">
                  <button class="delete" @click="success = undefined"></button>
                  {{ success }}
                </div>

                <p class="control" v-if="success">
                  <button class="button is-primary is-outlined is-fullwidth"
                    @click="$router.push('/login')"
                    :disabled="!success"
                    :class="">
                    Proceed To Login
                  </button>
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/apis/Auth'
export default {
  props: {
    // token: {
    //   default: '123'
    // }
  },
  data () {
    return {
      rememberMe: false,
      token: '',
      isLoading: true,
      error: '',
      errors: [],
      success: ''
    }
  },
  methods: {
    submit (token) {
      console.log('submitting token... ' + token)

      this.error = ''
      this.errors = []
      this.isLoading = true

      auth.verify(token)
      .then(data => {
        this.isLoading = false
        this.success = 'Verified successfully!'
        // this.$router.push('/home')
      })
      .catch(error => {
        console.error('login failed', error)
        if (error.error && typeof error.error === 'object') {
          this.errors = error.error
        } else if (error.error && typeof error.error === 'string') {
          this.error = error.error + ' Please verify using token or resend verification token again.'
        }

        this.isLoading = false
      })
    },
    proceed () {
      this.$route.push('/login')
    },
    onInput ({ name, value }) {
      if (!name) {
        console.error('invalid update key: ' + name)
        return
      }
      this.token = value
    }
  },
  created () {
  },
  mounted () {
    if (!this.$route.query.token ||
      typeof this.$route.query.token !== 'string' ||
      this.$route.query.token.length <= 0) {
      this.isLoading = false
      return
    }

    this.token = this.$route.query.token
    this.submit(this.$route.query.token)
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-verify {
}
</style>



// WEBPACK FOOTER //
// Verify.vue?71850596